import * as React from "react";
import { IProxyViewModel } from "viewmodels";
import { render } from "react-dom";
import { Widget } from "@modules/widget";

declare const Shopify: {
	shop: string;
};

{
    const configEl = document.getElementById("configJson");
    const hostDiv = document.getElementById("contenthost");

    if (!configEl) {
        throw new Error("Could not find element with id #configJson, unable to parse configuration.");
    }

    if (!hostDiv) {
        throw new Error("Could not find element with id #contenthost, unable to embed widget.");
    }

	const vm: IProxyViewModel = JSON.parse(configEl.innerHTML);
    const widget = (
        <Widget
            allowSearch={true}
            allowSearchViaOrderNumber={vm.allowWidgetSearchViaOrderNumber}
            hostDomain={vm.hostDomain}
            proxyPathPrefix={vm.pathPrefix}
            shopUrl={Shopify.shop}
        />
    )

    render(widget, hostDiv);
}
